import { CRMVerticalKey } from "@/models/crm-types";
import { FormResponseStatus } from "@/models/form-types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type CRMViewMode = "kanban" | "list";

interface CRMState {
  selectedVertical: CRMVerticalKey | null;
  selectedPersona: string | null;       // persona key, e.g. "designer"
  statusFilter: FormResponseStatus | "ALL";
  searchQuery: string;
  selectedParticipants: string[];        // UIDs for bulk actions
  viewMode: CRMViewMode;
}

const initialState: CRMState = {
  selectedVertical: null,
  selectedPersona: null,
  statusFilter: "ALL",
  searchQuery: "",
  selectedParticipants: [],
  viewMode: "kanban",
};

export const crmSlice = createSlice({
  name: "crm",
  initialState,
  reducers: {
    setSelectedVertical: (state, action: PayloadAction<CRMVerticalKey | null>) => {
      state.selectedVertical = action.payload;
      state.selectedPersona = null;
      state.selectedParticipants = [];
    },
    setSelectedPersona: (state, action: PayloadAction<string | null>) => {
      state.selectedPersona = action.payload;
      state.selectedParticipants = [];
    },
    setStatusFilter: (state, action: PayloadAction<FormResponseStatus | "ALL">) => {
      state.statusFilter = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setViewMode: (state, action: PayloadAction<CRMViewMode>) => {
      state.viewMode = action.payload;
    },
    toggleParticipantSelection: (state, action: PayloadAction<string>) => {
      const uid = action.payload;
      const index = state.selectedParticipants.indexOf(uid);
      if (index >= 0) {
        state.selectedParticipants.splice(index, 1);
      } else {
        state.selectedParticipants.push(uid);
      }
    },
    selectAllParticipants: (state, action: PayloadAction<string[]>) => {
      state.selectedParticipants = action.payload;
    },
    clearParticipantSelection: (state) => {
      state.selectedParticipants = [];
    },
    resetCrmFilters: (state) => {
      state.statusFilter = "ALL";
      state.searchQuery = "";
      state.selectedPersona = null;
      state.selectedParticipants = [];
    },
  },
});

export const {
  setSelectedVertical,
  setSelectedPersona,
  setStatusFilter,
  setSearchQuery,
  setViewMode,
  toggleParticipantSelection,
  selectAllParticipants,
  clearParticipantSelection,
  resetCrmFilters,
} = crmSlice.actions;

export default crmSlice.reducer;
